const singleLine = {
  id: 1,
  name: "One Table Row",
  description: "One Table Row -desc",
  picturePaths: null,
  arrangement: [
    [false, false, false, false],
    [false, false, false, false],
    [true, true, true, true],
    [false, false, false, false]
  ]
};

const doubleLine = {
  id: 2,
  name: "Two Table Row",
  description: "Two Table Row -desc",
  picturePaths: null,
  arrangement: [
    [false, false, false, false],
    [true, true, true, true],
    [false, false, false, false],
    [true, true, true, true]
  ]
};

const uShape = {
  id: 3,
  name: "U Shape",
  description: "U Shape -desc",
  picturePaths: null,
  arrangement: [
    [true, false, false, true],
    [true, false, false, true],
    [true, false, false, true],
    [true, true, true, true]
  ]
};

const lShape = {
  id: 4,
  name: "L Shape",
  description: "L Shape -desc",
  picturePaths: null,
  arrangement: [
    [true, false, false, false],
    [true, false, false, false],
    [true, false, false, false],
    [true, true, true, true]
  ]
};

/**
 * reference
 * { id: 1, arrangement: [[true, true]] },
 * { id: 2, arrangement: [[true, true, true]] },
 * { id: 3, arrangement: [[true, true], [true, true]] },
 * { id: 4, arrangement: [[true, true, true], [true, true, true]]}
 */
export const basicLayout = [singleLine, doubleLine, uShape, lShape];
